import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const EvaluationService = {
  async getAllRows(filters = {}) {
    try {
      const result = await axios.get(`${apiUrl}/Partner/Evaluation`, { params: filters });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

    return {
      status: 0,
      message: "Erreur de chargement des evaluations",
      data: [],
    };
  },

  async getPartnerRows(partnerId) {
    try {
      const result = await axios.get(`${apiUrl}/Partner/Evaluation/detail`, {
        params: { partnerId },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

    return {
      status: 0,
      message: "Erreur de chargement du detail d'evaluation",
      data: [],
    };
  },

  async getPartnerRowsByName(partnerName, sourceMenu = "Partenaires") {
    try {
      const result = await axios.get(`${apiUrl}/Partner/Evaluation/detailName`, {
        params: { partnerName, source_menu: sourceMenu },
      });
      return result.data;
    } catch (error) {
      return error.response?.data || { status: false, data: [] };
    }
  },
};

export default EvaluationService;
